import React from 'react';
import PropTypes from 'prop-types';

// Components
import { ButtonV2 } from '@zola/zola-ui';

// Styles
import './ConfirmExitModal.less';

/**
 * Confirm Exit Modal Component
 *
 * @param {boolean} showConfirmExitModal  - whether show or hide ConfirmExitModal
 * @param {function} hideConfirmExitModal - function to hide  ConfirmExitModal
 * @param {function} hideModalFn - function to hide parent modal
 */

const ConfirmExitModal = props => {
  const { hideConfirmExitModal, hideModalFn } = props;

  return (
    <div className="confirm-exit__modal">
      <div className="confirm-exit__content">
        <h3 className="confirm-exit__title">You have unsaved changes</h3>
        <p className="confirm-exit__intro">Go back and save them or your work will be lost</p>
        <div className="confirm-exit__buttons">
          <ButtonV2
            className="confirm-exit__ok"
            variant="secondary"
            onClick={() => {
              hideModalFn();
              hideConfirmExitModal();
            }}
          >
            Ok
          </ButtonV2>
          <ButtonV2 className="confirm-exit__no" onClick={() => hideConfirmExitModal()}>
            Go Back
          </ButtonV2>
        </div>
      </div>
    </div>
  );
};

ConfirmExitModal.propTypes = {
  hideConfirmExitModal: PropTypes.func,
  hideModalFn: PropTypes.func,
};

ConfirmExitModal.defaultProps = {
  hideConfirmExitModal: () => {},
  hideModalFn: () => {},
};

export default ConfirmExitModal;



// WEBPACK FOOTER //
// ./src/components/common/modals/ConfirmExitModal/ConfirmExitModal.jsx